export default function(product, villageLabels) {
  const contactMethods = []
  const virtualShoppingDetails =
    product?.brand?.content?.find(
      (c) => c.__typename === 'ContentfulCompVirtualShoppingDetailsVsd01'
    ) || {}

  if (virtualShoppingDetails && villageLabels) {
    if (
      villageLabels.whatsappLabel &&
      villageLabels.whatsappIcon &&
      virtualShoppingDetails.whatsapp
    ) {
      contactMethods.push({
        trackLabel: 'WhatsApp Number',
        icon: villageLabels.whatsappIcon,
        label: villageLabels.whatsappLabel,
        contact: `https://wa.me/${virtualShoppingDetails.whatsapp}`,
      })
    }

    if (
      villageLabels.productCatalogueLabel &&
      villageLabels.productCatalogueIcon &&
      virtualShoppingDetails.productCatalogue
    ) {
      contactMethods.push({
        trackLabel: 'Product Catalogue URL',
        icon: villageLabels.productCatalogueIcon,
        label: villageLabels.productCatalogueLabel,
        contact: virtualShoppingDetails.productCatalogue,
      })
    }

    if (
      villageLabels.bookingUrlLabel &&
      villageLabels.bookingUrlIcon &&
      virtualShoppingDetails.bookingUrl
    ) {
      contactMethods.push({
        trackLabel: 'Booking URL',
        icon: villageLabels.bookingUrlIcon,
        label: villageLabels.bookingUrlLabel,
        contact: virtualShoppingDetails.bookingUrl,
      })
    }

    if (
      villageLabels.emailAddressLabel &&
      villageLabels.emailAddressIcon &&
      virtualShoppingDetails.virtualShoppingEmail
    ) {
      contactMethods.push({
        trackLabel: 'Virtual Shopping Email',
        icon: villageLabels.emailAddressIcon,
        label: villageLabels.emailAddressLabel,
        contact: `mailto:${virtualShoppingDetails.virtualShoppingEmail}`,
      })
    }

    if (
      villageLabels.phoneNumberLabel &&
      villageLabels.phoneNumberIcon &&
      virtualShoppingDetails.virtualShoppingPhone
    ) {
      contactMethods.push({
        trackLabel: 'Virtual Shopping Phone',
        icon: villageLabels.phoneNumberIcon,
        label: villageLabels.phoneNumberLabel,
        contact: `tel:${virtualShoppingDetails.virtualShoppingPhone}`,
      })
    }
  }

  return contactMethods
}
